import { AbstractRepository } from '../AbstractRepository';
import { HandledTenant } from './types';
import ShellLocalStorageDAOImpl from '../../dao/ShellLocalStorageDAOImpl';
import { internalLogger } from '../../interface/v1/clientOsLogger';

export class HandledTenantsRepository extends AbstractRepository<
  HandledTenant[]
> {
  public static PREFIX_KEY = 'jshellHandledTenants';

  constructor(shellLocalStorageDAOImpl: ShellLocalStorageDAOImpl) {
    super({
      shellDAO: shellLocalStorageDAOImpl,
      prefixKey: HandledTenantsRepository.PREFIX_KEY
    });
  }

  saveAll(): HandledTenant[][] {
    /* istanbul ignore next */
    internalLogger?.debug?.d5?.({
      className: 'HandledTenantsRepository',
      methodName: 'saveAll()',
      message: 'Not supported in HandledTenantRepository.'
    });
    throw new Error('Method not implemented.');
  }

  findAll(): HandledTenant[][] {
    /* istanbul ignore next */
    internalLogger?.debug?.d5?.({
      className: 'HandledTenantsRepository',
      methodName: 'findAll()',
      message: 'Not supported in HandledTenantRepository.'
    });
    throw new Error('Method not implemented.');
  }
}
